'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import useSWR from 'swr';
import useSWRInfinite from 'swr/infinite';
import IconUser from '@/components/assets/icon_user.svg';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { getComments, getCommentsCount } from '@/services/cms';
import { Comment as CommentType } from '@/types/comments';
type MobileCommentsTriggerProps = {
  onClick: () => void;
};
function MobileCommentsTrigger(t0) {
  const $ = _c(23);
  const {
    onClick
  } = t0;
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t1;
  if ($[0] !== roomData.id) {
    t1 = () => getCommentsCount({
      roomId: roomData.id
    });
    $[0] = roomData.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      revalidateOnFocus: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: commentsCountData
  } = useSWR("comments/count", t1, t2);
  const commentsCount = commentsCountData?.pages?.total ?? 0;
  let t3;
  if ($[3] !== roomData.id) {
    t3 = pageIndex => {
      if (pageIndex > 0 || !roomData?.id) {
        return null;
      }
      return `comments?limit=1&room_id=${roomData.id}&cursor=`;
    };
    $[3] = roomData.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getKey = t3;
  let t4;
  if ($[5] !== roomData.id) {
    t4 = key => {
      const urlParams = new URLSearchParams(key.split("?")[1]);
      const cursor = urlParams.get("cursor") || "";
      return getComments({
        roomId: roomData.id,
        cursor,
        limit: 1
      });
    };
    $[5] = roomData.id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      revalidateFirstPage: false
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: commentsData
  } = useSWRInfinite(getKey, t4, t5);
  const firstComment = commentsData?.[0]?.results?.[0];
  let t6;
  if ($[8] !== t) {
    t6 = t("comments-panel.comments-count");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="subheader-4 text-vive-primary-30">{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = commentsCount ?? 0;
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="body1-omni-styles text-white landscape:text-sm landscape:leading-5.5">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div className="flex w-full items-center gap-1">{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== firstComment) {
    t11 = firstComment && <div className="flex w-full items-start gap-2.5"><Avatar className="bg-vive-brand-60 size-[34px] shrink-0"><AvatarImage src={firstComment.owner.head_icon_url} alt={firstComment.owner.display_name} className="object-cover" /><AvatarFallback><IconUser className="bg-vive-brand-60 size-full" /></AvatarFallback></Avatar><p className="line-clamp-2 min-w-0 flex-1 text-[14px] leading-[22px] tracking-[0.2px] wrap-break-word text-white">{firstComment.content}</p></div>;
    $[17] = firstComment;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onClick || $[20] !== t10 || $[21] !== t11) {
    t12 = <button type="button" data-section="comments-trigger-mobile" onClick={onClick} className="mb-2 flex w-full flex-col items-start gap-2 rounded-[10px] bg-white/10 p-3 text-left transition-colors hover:bg-white/15 active:bg-white/15">{t10}{t11}</button>;
    $[19] = onClick;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}
export default MobileCommentsTrigger;